export class RubiconSite {
  siteId: number;
  name: string;
  domain: string;
  displayName: string;
  contentCategoryIds: string[];
  sizeIds: number[];
}
